module.exports = ng.material.core;